<!-- IE 2026 10 22 / ODOO-5800 (Igor 22.10, скрин ВЕРСІЇ: «желательно, чтобы легенду можно было вынести за рамки формы ячейки» — форма легенды переносилась, но обрезалась
     границами формы ячейки (overflow контейнера)): ФОРМА ЛЕГЕНДЫ ЛЮБОГО ГРАФИКА ФОРМЫ ЯЧЕЙКИ — один компонент для VERSIONS / PLANS / запасов / Ганта (Dropdown.vue,
     CellSeriesChart.vue). Тело формы (строки легенды с фокусом / pin, флажки серий, подсказки) — слот родителя: обработчики остаются его. Форма рендерится через Teleport
     в body (в Full screen — в полноэкранный элемент, проп to) слоем поверх формы ячейки (z-index 10000 — как ручки размера .dropdown-handles, выше формы 9999 и линии
     привязки), position: fixed в координатах экрана: первое размещение — правый верх ВИДИМОЙ части блока, где стоит компонент (невидимый якорь → rect родителя ∩ окно ∩ предки с прокруткой, offsetTop / offsetRight),
     перенос за шапку — utils/legendDrag.js с ограничением окном (не формой); при прокрутке / переносе формы ячейки легенда остаётся на месте экрана; при закрытии формы
     или смене виджета компонент размонтируется — форма уходит. Повторное открытие — снова в углу блока -->
<template>
    <span class="cell-legend-anchor" ref="anchor" hidden></span>
    <Teleport :to="to || 'body'">
        <div :class="['dropdown-legend-pop', 'cell-legend-pop', cls]" :style="posStyle" ref="pop" v-uiHelp="'grid.cellForm.legend'" @pointerdown.stop @mousedown.stop @click.stop>
            <div class="dropdown-legend-head" :title="t('Drag to move')" @pointerdown="grab($event)">{{ title || t('Legend') }}<i class="pi pi-times dropdown-legend-close" :title="t('Close')" @click.stop="$emit('close')"></i></div>
            <slot></slot>
        </div>
    </Teleport>
</template>
<script>
import { t } from '@/i18n'
import { legendDrag_start, legendDrag_style, legendDrag_visibleRect, legendPop_place, LEGEND_POP_Z } from '@/utils/legendDrag'

export default {
    name: 'CellLegendPop',
    inheritAttrs: false,
    props: {
        to: { type: [String, Object], default: null },   // куда телепортировать (Full screen — полноэкранный элемент); null — body
        cls: { type: [String, Array], default: '' },      // дополнительные классы формы (стили тела у родителя)
        title: { type: String, default: '' },
        offsetTop: { type: Number, default: 4 },           // первое размещение: отступ от верха блока
        offsetRight: { type: Number, default: 6 },         // … и от правого края блока
    },
    emits: ['close'],
    data() { return { pos: null } },
    computed: {
        posStyle() {
            const st = { position: 'fixed', zIndex: LEGEND_POP_Z, visibility: this.pos ? '' : 'hidden', ...(legendDrag_style(this.pos) || {}) }
            if (this.pos) { st.maxHeight = Math.max(80, (typeof window !== 'undefined' ? window.innerHeight : 0) - this.pos.top - 8) + 'px'; st.overflowY = 'auto' }
            return st
        },
    },
    mounted() { this.$nextTick(() => this.place()) },
    methods: {
        t(k, p) { return t(k, p) },
        place() {
            const a = this.$refs.anchor, host = a && a.parentElement, pop = this.$refs.pop
            let hr = null
            try { hr = host ? (legendDrag_visibleRect(host) || host.getBoundingClientRect()) : null } catch (e) { hr = null }   // видимая часть блока (блок может быть прокручен внутри формы)
            this.pos = legendPop_place(hr, { w: pop ? pop.offsetWidth : 0, h: pop ? pop.offsetHeight : 0 }, { w: window.innerWidth, h: window.innerHeight }, this.offsetTop, this.offsetRight)
        },
        grab(e) { legendDrag_start(e, this.$refs.pop, (pos) => { this.pos = pos }, { origin: this.pos }) },   // перенос: ограничение — окно (предков с overflow у body нет)
    },
}
</script>
<style>
/* IE 2026 10 22 / ODOO-5800: форма легенды в слое над формой ячейки — базовые стили .dropdown-legend-pop / .dropdown-legend-* глобальные (Dropdown.vue); здесь — только слой */
.cell-legend-pop { box-sizing: border-box; }
</style>
